import { render, staticRenderFns } from "./hazopRiskTab.vue?vue&type=template&id=2f381d92"
import script from "./hazopRiskTab.vue?vue&type=script&lang=js"
export * from "./hazopRiskTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f381d92')) {
      api.createRecord('2f381d92', component.options)
    } else {
      api.reload('2f381d92', component.options)
    }
    module.hot.accept("./hazopRiskTab.vue?vue&type=template&id=2f381d92", function () {
      api.rerender('2f381d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/hazop/risk/hazopRiskTab.vue"
export default component.exports